(function(_){
    'use strict';
    _['CART.KEY']='Cesta';
    _['CART.CONFIRM']='Confirmar';
    _['CART.NEXT']='Siguiente';
    _['CART.EMPTY-CART']='¡La cesta está vacia!';
    _['CART.ADDRESS']='Dirección';
    _['CART.ORDER']='Pedido';
    _['CART.PAYMENT']='Pago';
    _['CART.PRODUCT-ADDED']='{0} productos añadidos a la cesta';
    _['CART.PRODUCT-ADDED(1)']='{0} producto añadido a la cesta';
    _['CART.GO-TO-CART']='Ir a la cesta';
    _['CART.CONTINUE']='Continuar';
    _['CART.AMOUNT']='Cantidad';
    _['CART.PRICE']='Precio';
    _['CART.TOTAL']='Total';

    _['CART.ORDER.REMOVE']='Eliminar producto';
    _['CART.ORDER.PRICES.TITLE']='Resumen de tu compra';
    _['CART.ORDER.PRICES.TOTAL']='Precio';
    _['CART.ORDER.PRICES.TAXES']='IVA';
    _['CART.ORDER.PRICES.SHIPPING-CHARGES']='Gastos de envío';
    _['CART.ORDER.PRICES.TOTALWITHTAXES']='Total';
    _['CART.ORDER.PRICES.TOTALWITHTAXESUSD']='Total (USD)';
    _['CART.ORDER.PRICES.PAYPAL.WARNING.TEXT']='Esta moneda no está soportada por PayPal. Por favor, ten en cuenta que el cobro final se realizará en USD y será tu banco quien calculará la tasa de cambio final.';
    _['CART.ORDER.PRICES.REDSYS.WARNING.TEXT']='Esta moneda no está soportada por la pasarela de pago (Redsys). Por favor, ten en cuenta que el cobro final se realizará en USD y será tu banco quien calculará la tasa de cambio final.';

    _['CART.STOCK-STATUS']='Estado del stock';
    _['CART.STOCK-STATUS.OK']='OK';
    _['CART.STOCK-STATUS.OK.DESC']='Todos los productos tienen stock';
    _['CART.STOCK-STATUS.ERR']='Error';
    _['CART.STOCK-STATUS.ERR.DESC']='Algún/os producto/s está/n fuera de stock';
    _['CART.FINAL-PRICE']='Precio final';
    _['CART.ORDER.REMOVAL-CONFIRM.TITLE']='Retirar producto del pedido';
    _['CART.ORDER.REMOVAL-CONFIRM.MSG']='¿Estás seguro?';
    _['CART.ADDRESS.EDIT']='Editar';
    _['CART.ADDRESS.SHIPPING']='Dirección de envío';
    _['CART.ADDRESS.BILLING']='Dir. de facturación';
    _['CART.ADDRESS.OBSERVATIONS']='Observaciones';
    _['CART.ADDRESS.PAYMENT_MODEL']='Método de pago';
    _['CART.ADDRESS.PAY_WITH_REDSYS']='Pagar ahora con tarjeta de crédito';
    _['CART.ADDRESS.PAY_WITH_PICK_AT_STORE']='Pagar cuando recoja en tienda';
    _['CART.ADDRESS.PAY_WITH_PAYPAL']='Pagar ahora con PayPal';
    _['CART.ADDRESS.PAY_WITH_REFUND']='Pagar a contra-reembolso';
    _['CART.ADDRESS.PAY_WITH_WIRE_TRANSFER']='Pagar mediante transferencia bancaria';
    _['CART.ADDRESS.NO.PAYMENT_MODEL.MSG']='No existe ningún método de pago preconfigurado. Contacte con el administrador de la App.';

    _['CART.ADDRESS.SAME-AS-SHIPPING']='Igual que dirección de envío';

    _['CART.PAYMENT.PAYPAL.ADVICE']='Serás reenviado a la página de PayPal para realizar el pago.';
    _['CART.PAYMENT.PAYPAL.REDIRECTING']='Redirigiendo a PayPal';
    _['CART.PAYMENT.PAYPAL.BTN']='¡Realizar el pago!';
    _['CART.PAYMENT.REFUND.ADVICE']='Vas a confirmar el pago de tu pedido. Repasa atentamente todos los datos y pulsa el botón "¡Confirmar pedido!".';
    _['CART.PAYMENT.REFUND.REDIRECTING']='Confirmar el pedido';
    _['CART.PAYMENT.REFUND.BTN']='¡Confirmar el pedido!';
    _['CART.PAYMENT.WIRE_TRANSFER.ADVICE']='Vas a confirmar el pago de tu pedido. Repasa atentamente todos los datos y pulsa el botón "¡Confirmar pedido!".';
    _['CART.PAYMENT.WIRE_TRANSFER.REDIRECTING']='¡Confirmar el pedido!';
    _['CART.PAYMENT.WIRE_TRANSFER.BTN']='¡Confirmar el pedido!';
    _['CART.PAYMENT.REDSYS.ADVICE']='Serás reenviado a la página de Redsys para realizar el pago.';
    _['CART.PAYMENT.REDSYS.REDIRECTING']='Redirigiendo a Redsys';
    _['CART.PAYMENT.REDSYS.BTN']='¡Realizar el pago!';
    _['CART.PAYMENT.PICKATSTORE.BTN']='¡Confirmar el pedido!';
    _['CART.PAYMENT.PICKATSTORE.ADVICE']='Vas a confirmar tu pedido. Repasa atentamente todos los datos y pulsa el botón "¡Confirmar pedido!".';

    _['CART.PAYMENT.ERR.SERVER.PREPARE.TITLE']='Error en el pago.';
    _['CART.PAYMENT.ERR.SERVER.PREPARE.MSG']='Ha ocurrido un error realizando el pago. Contacta con tu administrador/Vendedor.';

    _['CART.PAYMENT.WIRE_TRANSFER.TEXT'] = 'Has seleccionado el pago mediante transferencia bancaria. A continuación encontrarás los datos para realizarla y el email donde deberás enviar el justificante de dicha transferencia.';
    _['CART.PAYMENT.WIRE_TRANSFER.BANK-ACCOUNT'] = 'Número de cuenta bancaria';
    _['CART.PAYMENT.WIRE_TRANSFER.EMAIL'] = 'Email';

    _['CART.PAYMENT.SUCCESS.TITLE']='Tu pago ha sido recibido';
    _['CART.PAYMENT.SUCCESS.TITLE_RECEIVED']='Tu pedido ha sido recibido';
    _['CART.PAYMENT.SUCCESS.TITLE_WIRE_TRANSFER']='Tu pedido ha sido recibido';
    _['CART.PAYMENT.SUCCESS.MSG']='Gracias por el pago. La transacción ha sido completada y se te ha enviado un email con la información de la compra.';
    _['CART.PAYMENT.SUCCESS.MSG_RECEIVED']='Gracias por tu pedido. Todo ha ido bien y se te ha enviado un email con la información del pedido.';
    _['CART.PAYMENT.SUCCESS.MSG_WIRE_TRANSFER']='Gracias por tu pedido. Todo ha ido bien y se te ha enviado un email con la información del pedido.';
    _['CART.PAYMENT.FAILURE.TITLE']='Error procesando el pago';
    _['CART.PAYMENT.FAILURE.MSG']='Lo lamentamos, no hemos podido completar la transacción, ha ocurrido un error procesando el pago. Contacta con tu administrador/vendedor.';
    _['CART.PAYMENT.SHIPPINGCHARGES.TITLE'] = 'Gastos de envio';
    _['CART.PAYMENT.SHIPPINGCHARGES.FIXED'] = 'Gastos de envio fijos';
    _['CART.PAYMENT.SHIPPINGCHARGES.MSG'] = 'Gastos de envio gratuitos en este pedido.';
    _['CART.PAYMENT.PICKATSTOREOPTIONS.TITLE'] = 'Recogida en tienda';
    _['CART.MIMINUMORDER'] = 'El pedido debe superar la cantidad mínima de ';

}(translations['es']));



// WEBPACK FOOTER //
// ./src/app/modules/cart/lang/cart-lang_es.js